export default __webpack_public_path__ + "static/media/card1.422ebb1c.png";